import { useMutation } from '@tanstack/react-query'
import { axiosInstance } from '@/lib/axios'

interface ChangePassProps {
  new_password: string
  old_password: string
}

export const changePass = async (data: ChangePassProps) => {
  return axiosInstance.post('/user/change-email-and-password', data)
}

export const useChangePass = () => {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: changePass,
    mutationKey: ['change_pass'],
  })

  return { changePassAsync: mutateAsync, isChangingPass: isPending }
}
